export default "__VITE_ASSET__L3D6CWqR__"